const HERE_API_KEY = process.env.REACT_APP_HERE_API_KEY || ''
export const HERE_TILE_URL = `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png?lang=nl&features=pois:disabled&apiKey=${HERE_API_KEY}`
